import { PrismaticEmbed } from 'components/gms/PrismaticEmbed';
import { showWorkflows } from 'services/prismaticService';

export const IntegrationsWorkflows = () => (
  <PrismaticEmbed
    embedFunction={showWorkflows}
    containerId="prismatic-workflows"
  />
);
